import Vue from 'vue'
import VueRouter from 'vue-router'
import { canNavigate } from '@/libs/acl/routeProtection'
import {
  isUserLoggedIn, isGoingToLogging, isAdmin, isExternalAccess, isGoingToHome,
} from '@/auth/utils'
import appModules from '../app-modulo/documento/router/index'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: appModules,
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (!isGoingToLogging(from, to)) {
    if (to.meta.requiredAuth === false) {
      next()
      return
    }
    if (isUserLoggedIn()) {
      const external = isExternalAccess()
      // Se for o portal do cliente e estiver indo para a pagina home, que apenas a auditar tem acesso
      if (external && isGoingToHome(from, to)) {
        next({
          path: '/portal-cliente/portal',
          query: { redirect: to.fullPath },
        })
        return
      }
      // Se pode alterar a rota :)
      if (isAdmin() || (!isAdmin() && canNavigate(to))) {
        if (external && !localStorage.getItem('empresaSelecionada')) {
          next({
            path: '/portal-cliente/selecionar-empresa',
            query: { redirect: to.fullPath },
          })
          return
        }
        next()
        return
      }

      // Se não tem acesso a rota tem que ver para qual login ele será redirecionado
      if (!canNavigate(to)) {
        if (external) {
          next({
            path: '/portal-cliente/login',
            query: { redirect: to.fullPath },
          })
          return
        }

        next({
          path: '/login',
          query: { redirect: to.fullPath },
        })
        return
      }
    }

    // // Se não está logado é necessário ir para o login, mas para qual?
    if (isExternalAccess()) {
      next({
        path: '/portal-cliente/login',
        query: { redirect: to.fullPath },
      })
      return
    }
    next({
      path: '/login',
      query: { redirect: to.fullPath },
    })
    // next({
    //   path: '/login',
    //   query: { redirect: to.fullPath },
    // })
    return
  }
  setTimeout(() => next(), 5)
})

export default router
